module.exports = __webpack_public_path__ + "static/img/20012 (1).f780182.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20012 (1).webp
// module id = OiPN
// module chunks = 14